import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-objective-skills',
  templateUrl: './admin-objective-skills.component.html',
  styleUrls: ['./admin-objective-skills.component.css']
})
export class AdminObjectiveSkillsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
